<template>
	<TechnologySection>
		<template #heading>
			High-<br v-if="appStore.isMobile" />performance&nbsp;<br v-if="appStore.isMobile" />
			technology
		</template>
		<template #content>
			<p class="body-xl mb-200-md mb-150-smo mt-50-md">
				We’ve spent 10+ years systematically replacing the industry standard of spreadsheets, PDFs, and
				expensive 3rd-party vendors with API-driven, fully integrated investor servicing, fund management, and
				asset management software.
			</p>
			<p class="body-lg">
				<strong>Our end-to-end, fully integrated technology platform is an industry first,</strong>
				drastically reducing operating costs, enabling sophisticated use of data, and delivering improved
				performance management. The results are dramatic:
			</p>
			<ul class="body-lg ul features-list ml-50 mt-250-md mt-0-smo">
				<li> Unprecedented real-time oversight & reporting </li>
				<li> Low fees, with no promote or carried interest </li>
				<li> Virtually unlimited scale </li>
				<li> Unprecedented convenience </li>
				<li> Better expected net returns </li>
			</ul>
		</template>
		<template #list>
			<TechnologySectionList />
		</template>
	</TechnologySection>
</template>

<script setup lang="ts">
import TechnologySection from '@components/marketing-site/technology-section.vue';
import TechnologySectionList from '@components/marketing-site/explore-technology-section-list.vue';
import { useAppStore } from '@stores/app';

const appStore = useAppStore();
</script>
<style lang="scss" scoped>
ul.features-list > li {
	line-height: 2;
}
</style>
